import { useTranslation } from 'react-i18next';
import EPageHeader from '@/components/everridge/EPageHeader';
import useMediaQuery from '@/hooks/useMediaQuery';
import { cn } from '@/lib/utils';
import { AppConfig } from '@/config/app.config';
import { useState } from 'react';
import EFilterButton from '@/components/everridge/EFilterButton';
import { FilterHelper } from '@/utils/filterHelper';
import { useFinancesPageFilter } from './store/useFinancesPageFilter';
import FinancePageFilter from './components/FinancePageFilter';
import FinancesPageSettlements from './components/Settlements/FinancesPageSettlements';
import FinancesPageBalance from './components/Balance/FinancesPageBalance';
import FinancesPageTransactions from './components/Transactions/FinancesPageTransactions';
import FinancesPageAnalytics from './components/Analytics/FinancesPageAnalytics';

const FinancesPage = () => {
    const [showFilter, setShowFilter] = useState(false);

    const { t } = useTranslation();
    const isMobile = useMediaQuery(AppConfig.mediaQueries.mobile);

    const { filter } = useFinancesPageFilter();

    const filtersQuantity = FilterHelper.countFilterValues(filter);

    return (
        <section className={cn('flex flex-col gap-6', isMobile && 'gap-4')}>
            <EPageHeader title={t('main.finances.title')}>
                <EFilterButton
                    name={t('elements.buttons.filter')}
                    filtersQuantity={filtersQuantity}
                    onClick={() => setShowFilter(true)}
                    isMobile={isMobile}
                />
            </EPageHeader>
            <div className={cn('h-full grid grid-cols-1 gap-4', !isMobile && 'grid-cols-2 gap-6')}>
                <FinancesPageSettlements isMobile={isMobile} className={cn(isMobile && 'order-1')} />
				<FinancesPageBalance isMobile={isMobile} className={cn(isMobile && 'order-3')} />
				<FinancesPageTransactions isMobile={isMobile} className={cn(isMobile && 'order-2')} />
				<FinancesPageAnalytics isMobile={isMobile} className={cn(isMobile && 'order-4')} />
            </div>
            {showFilter && (
                <FinancePageFilter onClose={() => setShowFilter(false)} isMobile={isMobile} />
            )}
        </section>
    );
};

export default FinancesPage;
